export type AdminMenuItem = {
  name?: string;
  path?: string;
  children?: AdminMenuItem[];
};

export const isDashboardMenuItem = (item: AdminMenuItem) =>
  item.name === '首页' ||
  item.name === 'luole-admin.dashboard' ||
  String(item.path || '').startsWith('/dashboard');

export const isOpsMenuItem = (item: AdminMenuItem) =>
  item.name === '招聘工作台' ||
  item.name === 'luole-admin.ops' ||
  String(item.path || '') === '/ops' ||
  String(item.path || '').startsWith('/ops/');

export const assembleAdminMenu = <T extends AdminMenuItem>(
  remainingMenu: T[],
  groupedMenu: T[],
) => {
  const dashboardItems = remainingMenu.filter(isDashboardMenuItem);
  const groupedOpsItems = groupedMenu.filter(isOpsMenuItem);
  const leftoverOpsItems = remainingMenu.filter(
    (item) =>
      isOpsMenuItem(item) &&
      !isDashboardMenuItem(item) &&
      groupedOpsItems.length === 0,
  );
  const otherRemaining = remainingMenu.filter(
    (item) => !isDashboardMenuItem(item) && !isOpsMenuItem(item),
  );
  const otherGrouped = groupedMenu.filter((item) => !isOpsMenuItem(item));

  return [
    ...dashboardItems,
    ...groupedOpsItems,
    ...leftoverOpsItems,
    ...otherGrouped,
    ...otherRemaining,
  ];
};
